import {
  type CanvasElement,
  type CanvasElementId,
  type SlotId,
} from '@blaze-runtime/engine-domain';

export interface ElementPathEntry {
  id: CanvasElementId;
  slotId?: SlotId;
}

export const getParentElement = (
  elementId: CanvasElementId,
  allElements: CanvasElement[],
): CanvasElement | undefined => {
  return allElements.find((el) => {
    if (el.id === elementId) {
      return false;
    }
    const slots = el.slots;
    const slotIds = slots?.ids ?? [];
    return slotIds.some((slotId) => slots?.[slotId]?.children?.includes(elementId));
  });
};

export function calculateElementPath(
  elementId: CanvasElementId | undefined,
  slotId: SlotId | undefined,
  elements: CanvasElement[],
): ElementPathEntry[] {
  if (!elementId) {
    return [];
  }
  const path: ElementPathEntry[] = [
    {
      id: elementId,
      slotId: slotId,
    },
  ];

  let currentElementId: CanvasElementId | undefined = elementId;

  while (currentElementId) {
    const parent = getParentElement(currentElementId, elements);
    if (!parent) {
      break;
    }
    const slotIds = parent.slots?.ids ?? [];
    const parentSlotId = slotIds.find(
      (slotId) => currentElementId && parent.slots?.[slotId]?.children.includes(currentElementId),
    );
    if (parentSlotId) {
      path.push({
        id: parent.id,
        slotId: parentSlotId,
      });
    }
    currentElementId = parent.id;
  }
  return path.reverse();
}
